



// import React from 'react';
// import ReactMarkdown from 'react-markdown';
// import { getPalette } from '../../ColorPalette';
// import backdropImage from '../../images/BackdropNight.png';

// export const post = {
//   slug: "introducingplusonesrs",
//   title: 'Introducing "+1 SRS"',
//   date: "2025-04-09",
//   summary: 'Discover our core sentence retrieval algorithm that blends comprehensible input with spaced repetition.',
// };

// const content = `
// # Introducing "+1 SRS"

// *Published: 2025-04-04*

// At the core of Flash Fluency is our **+1 SRS algorithm**—the system that delivers content tailored to your exact proficiency, right when you need it. But what the heck is +1? And what's SRS?

// ---

// ## +1 (Comprehensible Input)

// The term "+1" comes from the educational theory of comprehensible input—language that's just slightly beyond your current level. It pushes you without overwhelming you.

// ---

// ## SRS (Spaced Repetition System)

// Spaced Repetition Systems (SRS) are based on a cognitive principle: you're more likely to retain information when reviews are spaced out over time. Classic SRS apps like Anki adjust card timing based on how easy or hard you say each one was.

// ---

// ## So What Makes +1 SRS Different?

// ### Concept-Level +1 Granularity

// Most systems approach +1 at the granularity level of graded content. At Flash Fluency, we've taken this a step further with the idea of a "+1 sentence". A +1 sentence is a sentence that introduces exactly one new vocabulary word or grammar point to the user. Every single sentence you see is +1.

// ### Concept-Level SRS

// Most SRS systems operate at the flashcard level. We operate at the concept level—tracking your understanding of each individual grammar point and vocabulary item, not just the sentence as a whole.

// ---

// ## Why This Matters

// Conventional flashcard systems make you rate the entire sentence, even if you only missed one word or grammar detail. Flash Fluency lets you mark just the specific elements you don't know. We track your progress at the concept level, so mastered concepts are reviewed less frequently, while areas needing improvement get the focus they deserve. This precision approach optimizes study time, reduces redundant reviews, and reinforces long-term retention.

// As our system grows, you'll see even more just why this concept-level tracking is so important!

// ---

// ## Continual Improvement

// - **Advanced Lexeme Tagging:** We'll soon track subtle variations (like conjugations or nuances), helping you learn vocab more deeply and across diverse contexts.
// - **Multi-Meaning Vocabulary:** Some words (like 걸리다) have tons of meanings. While we already prioritize the most common ones, we have plans to introduce them one at a time in a more optimized manner.
// - **More Data:** As our data repository continues to grow, so will our ability to deliver you increasingly more optimized sentences.  For example, we'll be able to more frequently provide you with sentences that simultaneously introduce a new concept (vocab or grammar) while also reviewing an at-risk-of-being-forgotten concept. This "two birds, one stone" approach means less time spent on redundant review and more time progressing.
// ---

// We're committed to becoming the most effective and efficient Korean language learning system. Thanks for being part of the journey ^_^
// `;

// export default function IntroducingPlusOneSRS() {
//   const colors = getPalette('dark');

//   return (
//     <div
//       style={{
//         minHeight: '100vh',
//         backgroundImage: `url(${backdropImage})`,
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//         backgroundRepeat: 'no-repeat',
//         backgroundAttachment: 'fixed',
//         backgroundColor: colors.background,
//         fontFamily: 'sans-serif',
//         color: colors.text
//       }}
//     >
//       <div style={{ 
//         maxWidth: '1024px', 
//         margin: '0 auto', 
//         padding: '40px 16px' 
//       }}>
//         <div
//           style={{
//             maxWidth: '65ch',
//             margin: '0 auto',
//             backgroundColor: colors.container,
//             boxShadow: `0 4px 16px ${colors.shadow}`,
//             borderRadius: '12px',
//             padding: '32px 48px',
//             border: `1px solid ${colors.borderSilver}`
//           }}
//         >
//           <div
//             style={{
//               lineHeight: '1.8',
//               color: colors.text
//             }}
//             className="markdown-content"
//           >
//             <ReactMarkdown
//               components={{
//                 h1: ({node, ...props}) => (
//                   <h1 style={{ 
//                     fontSize: '32px', 
//                     fontWeight: '800', 
//                     color: colors.text,
//                     marginBottom: '8px',
//                     marginTop: '24px'
//                   }} {...props} />
//                 ),
//                 h2: ({node, ...props}) => (
//                   <h2 style={{ 
//                     fontSize: '24px', 
//                     fontWeight: '600', 
//                     color: colors.progressBarFg,
//                     marginBottom: '12px',
//                     marginTop: '32px'
//                   }} {...props} />
//                 ),
//                 h3: ({node, ...props}) => (
//                   <h3 style={{ 
//                     fontSize: '20px', 
//                     fontWeight: '600', 
//                     color: colors.text,
//                     marginBottom: '8px',
//                     marginTop: '24px'
//                   }} {...props} />
//                 ),
//                 p: ({node, ...props}) => (
//                   <p style={{ 
//                     marginBottom: '16px',
//                     opacity: 0.9,
//                     fontSize: '16px'
//                   }} {...props} />
//                 ),
//                 em: ({node, ...props}) => (
//                   <em style={{ 
//                     opacity: 0.7,
//                     fontSize: '14px'
//                   }} {...props} />
//                 ),
//                 strong: ({node, ...props}) => (
//                   <strong style={{ 
//                     fontWeight: '600',
//                     color: colors.progressBarFg
//                   }} {...props} />
//                 ),
//                 ul: ({node, ...props}) => (
//                   <ul style={{ 
//                     marginLeft: '24px',
//                     marginBottom: '16px',
//                     listStyleType: 'disc'
//                   }} {...props} />
//                 ),
//                 li: ({node, ...props}) => (
//                   <li style={{ 
//                     marginBottom: '8px'
//                   }} {...props} />
//                 ),
//                 hr: ({node, ...props}) => (
//                   <hr style={{ 
//                     border: 'none',
//                     borderTop: `1px solid ${colors.borderSilver}`,
//                     margin: '32px 0',
//                     opacity: 0.5
//                   }} {...props} />
//                 ),
//                 code: ({node, inline, ...props}) => 
//                   inline ? (
//                     <code style={{
//                       backgroundColor: `${colors.borderSilver}30`,
//                       padding: '2px 6px',
//                       borderRadius: '4px',
//                       fontSize: '14px',
//                       fontFamily: 'monospace'
//                     }} {...props} />
//                   ) : (
//                     <code style={{
//                       display: 'block',
//                       backgroundColor: `${colors.borderSilver}20`,
//                       border: `1px solid ${colors.borderSilver}`,
//                       borderRadius: '8px',
//                       padding: '16px',
//                       overflowX: 'auto',
//                       marginBottom: '16px',
//                       fontSize: '14px',
//                       fontFamily: 'monospace'
//                     }} {...props} />
//                   )
//               }}
//             >
//               {content}
//             </ReactMarkdown>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }




import React from 'react';
import ReactMarkdown from 'react-markdown';
import { getPalette } from '../../ColorPalette';
import backdropImage from '../../images/BackdropNight.png';

export const post = {
  slug: "introducingplusonesrs",
  title: 'Introducing "+1 SRS"',
  date: "2025-04-09",
  summary: 'Discover our core sentence retrieval algorithm that blends comprehensible input with spaced repetition.',
};

const content = `
# Introducing "+1 SRS"

*Published: 2025-04-04*

At the core of Flash Fluency is our **+1 SRS algorithm**—the system that delivers content tailored to your exact proficiency, right when you need it. But what the heck is +1? And what's SRS?

---

## +1 (Comprehensible Input)

The term "+1" comes from the educational theory of comprehensible input—language that's just slightly beyond your current level. It pushes you without overwhelming you.

---

## SRS (Spaced Repetition System)

Spaced Repetition Systems (SRS) are based on a cognitive principle: you're more likely to retain information when reviews are spaced out over time. Classic SRS apps like Anki adjust card timing based on how easy or hard you say each one was.

---

## So What Makes +1 SRS Different?

### Concept-Level +1 Granularity

Most systems approach +1 at the granularity level of graded content. At Flash Fluency, we've taken this a step further with the idea of a "+1 sentence". A +1 sentence is a sentence that introduces exactly one new vocabulary word or grammar point to the user. Every single sentence you see is +1.

### Concept-Level SRS

Most SRS systems operate at the flashcard level. We operate at the concept level—tracking your understanding of each individual grammar point and vocabulary item, not just the sentence as a whole.

---

## Why This Matters

Conventional flashcard systems make you rate the entire sentence, even if you only missed one word or grammar detail. Flash Fluency lets you mark just the specific elements you don't know. We track your progress at the concept level, so mastered concepts are reviewed less frequently, while areas needing improvement get the focus they deserve. This precision approach optimizes study time, reduces redundant reviews, and reinforces long-term retention.

As our system grows, you'll see even more just why this concept-level tracking is so important!

---

## Continual Improvement

- **Advanced Lexeme Tagging:** We'll soon track subtle variations (like conjugations or nuances), helping you learn vocab more deeply and across diverse contexts.
- **Multi-Meaning Vocabulary:** Some words (like 걸리다) have tons of meanings. While we already prioritize the most common ones, we have plans to introduce them one at a time in a more optimized manner.
- **More Data:** As our data repository continues to grow, so will our ability to deliver you increasingly more optimized sentences.  For example, we'll be able to more frequently provide you with sentences that simultaneously introduce a new concept (vocab or grammar) while also reviewing an at-risk-of-being-forgotten concept. This "two birds, one stone" approach means less time spent on redundant review and more time progressing.
---

We're committed to becoming the most effective and efficient Korean language learning system. Thanks for being part of the journey ^_^
`;

export default function IntroducingPlusOneSRS() {
  const colors = getPalette('dark');

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundImage: `url(${backdropImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundColor: colors.background,
        fontFamily: 'sans-serif',
        color: colors.text
      }}
    >
      <div style={{ 
        maxWidth: '1024px', 
        margin: '0 auto', 
        padding: '40px 16px' 
      }}>
        <div
          style={{
            maxWidth: '65ch',
            margin: '0 auto',
            backgroundColor: colors.container,
            boxShadow: `0 4px 16px ${colors.shadow}`,
            borderRadius: '12px',
            padding: '32px 48px',
            border: `1px solid ${colors.borderSilver}`
          }}
        >
          <div
            style={{
              lineHeight: '1.8',
              color: colors.text
            }}
            className="markdown-content"
          >
            <ReactMarkdown
              components={{
                h1: ({node, children, ...props}) => (
                  <h1 style={{ 
                    fontSize: '32px', 
                    fontWeight: '800', 
                    color: colors.text,
                    marginBottom: '8px',
                    marginTop: '24px'
                  }} {...props}>
                    {children}
                  </h1>
                ),
                h2: ({node, children, ...props}) => (
                  <h2 style={{ 
                    fontSize: '24px', 
                    fontWeight: '600', 
                    color: colors.progressBarFg,
                    marginBottom: '12px',
                    marginTop: '32px'
                  }} {...props}>
                    {children}
                  </h2>
                ),
                h3: ({node, children, ...props}) => (
                  <h3 style={{ 
                    fontSize: '20px', 
                    fontWeight: '600', 
                    color: colors.text,
                    marginBottom: '8px',
                    marginTop: '24px'
                  }} {...props}>
                    {children}
                  </h3>
                ),
                p: ({node, ...props}) => (
                  <p style={{ 
                    marginBottom: '16px',
                    opacity: 0.9,
                    fontSize: '16px'
                  }} {...props} />
                ),
                em: ({node, ...props}) => (
                  <em style={{ 
                    opacity: 0.7,
                    fontSize: '14px'
                  }} {...props} />
                ),
                strong: ({node, ...props}) => (
                  <strong style={{ 
                    fontWeight: '600',
                    color: colors.progressBarFg
                  }} {...props} />
                ),
                ul: ({node, ...props}) => (
                  <ul style={{ 
                    marginLeft: '24px',
                    marginBottom: '16px',
                    listStyleType: 'disc'
                  }} {...props} />
                ),
                li: ({node, ...props}) => (
                  <li style={{ 
                    marginBottom: '8px'
                  }} {...props} />
                ),
                hr: ({node, ...props}) => (
                  <hr style={{ 
                    border: 'none',
                    borderTop: `1px solid ${colors.borderSilver}`,
                    margin: '32px 0',
                    opacity: 0.5
                  }} {...props} />
                ),
                code: ({node, inline, ...props}) => 
                  inline ? (
                    <code style={{
                      backgroundColor: `${colors.borderSilver}30`,
                      padding: '2px 6px',
                      borderRadius: '4px',
                      fontSize: '14px',
                      fontFamily: 'monospace'
                    }} {...props} />
                  ) : (
                    <code style={{
                      display: 'block',
                      backgroundColor: `${colors.borderSilver}20`,
                      border: `1px solid ${colors.borderSilver}`,
                      borderRadius: '8px',
                      padding: '16px',
                      overflowX: 'auto',
                      marginBottom: '16px',
                      fontSize: '14px',
                      fontFamily: 'monospace'
                    }} {...props} />
                  )
              }}
            >
              {content}
            </ReactMarkdown>
          </div>
        </div>
      </div>
    </div>
  );
}